import { DashboardLayout } from '../models/dashboard-layout.model';

export const DASHBOARD_LAYOUT_VERSION = 2;

export const defaultDashboardLayout: DashboardLayout = {
    version: DASHBOARD_LAYOUT_VERSION,
    widgets: [
        { id: 'aiReport', visible: true, x: 0, y: 0, w: 6, h: 24 },
        { id: 'totalInventory', visible: true, x: 6, y: 0, w: 3, h: 3 },
        { id: 'offlineInventory', visible: true, x: 6, y: 3, w: 3, h: 3 },
        { id: 'inventoryStatus', visible: true, x: 9, y: 0, w: 3, h: 6 },
        { id: 'efficiency', visible: true, x: 6, y: 12, w: 6, h: 6 },
        { id: 'activeMaintenance', visible: true, x: 6, y: 6, w: 3, h: 6 },
        { id: 'notInMotion', visible: true, x: 9, y: 18, w: 3, h: 6 },
        { id: 'efficiencyRanking', visible: true, x: 6, y: 18, w: 3, h: 6 },
        { id: 'criticalNotifications', visible: true, x: 9, y: 6, w: 3, h: 6 }
    ]
};

// For users who can't see the AI report: it sits alone in the top rows, which collapse when rendered.
export const defaultDashboardLayoutWithoutAi: DashboardLayout = {
    version: DASHBOARD_LAYOUT_VERSION,
    widgets: [
        { id: 'aiReport', visible: true, x: 0, y: 0, w: 6, h: 24 },
        { id: 'totalInventory', visible: true, x: 0, y: 24, w: 3, h: 3 },
        { id: 'offlineInventory', visible: true, x: 0, y: 27, w: 3, h: 3 },
        { id: 'inventoryStatus', visible: true, x: 3, y: 24, w: 3, h: 6 },
        { id: 'efficiency', visible: true, x: 6, y: 24, w: 6, h: 6 },
        { id: 'activeMaintenance', visible: true, x: 3, y: 30, w: 3, h: 6 },
        { id: 'notInMotion', visible: true, x: 9, y: 30, w: 3, h: 6 },
        { id: 'efficiencyRanking', visible: true, x: 6, y: 30, w: 3, h: 6 },
        { id: 'criticalNotifications', visible: true, x: 0, y: 30, w: 3, h: 6 }
    ]
};

export const getDefaultDashboardLayout = (aiReportAvailable: boolean) =>
    aiReportAvailable ? defaultDashboardLayout : defaultDashboardLayoutWithoutAi;

// `custom` is null while the user is on the default layout; the effective default then depends on
// whether the AI report is available. Older persisted state without `custom` reads as default.
export interface DashboardLayoutState {
    custom: DashboardLayout | null;
}

const initialDashboardLayoutState: DashboardLayoutState = {
    custom: null
};

export default initialDashboardLayoutState;
